import { loginRequest, msalInstanceKm, msalInstanceLdt } from '@/entraConfig';
import type { IPublicClientApplication } from '@azure/msal-browser';

export type EntraSsoButton = 'sso-km' | 'sso-ldt';

const instances: Record<EntraSsoButton, IPublicClientApplication | undefined> = {
    'sso-km': msalInstanceKm,
    'sso-ldt': msalInstanceLdt,
};

export function useEntraLogin() {
    async function loginWithEntra(provider: EntraSsoButton): Promise<string> {
        const instance = instances[provider];
        if (!instance) {
            throw new Error(`SSO provider not configured on frontend: ${provider}`);
        }
        const result = await instance.loginPopup(loginRequest);
        if (!result.idToken) {
            throw new Error('No ID token returned from Entra login');
        }
        return result.idToken;
    }

    return { loginWithEntra };
}
